<template>
    <v-form v-model="form_validation">
        <v-expansion-panels v-model="panel">
            <v-expansion-panel
                    v-for="payment in bulkPayments"
                    :key="payment.id"
            >
                <v-expansion-panel-header>
                    {{ payment.description }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-text-field
                            id="sum"
                            v-model="payment.sum"
                            :label="'Sum (EUR)' | t"
                            :rules="[v => !!v || 'Sum is required']"
                            placeholder="18.32"
                            prepend-icon="euro_symbol"
                            type="number"
                            @keypress="onlyIntegersWithComa"
                    />
                    <v-text-field
                            id="description"
                            v-model="payment.description"
                            :label="'Description' | t"
                            counter="140"
                            :placeholder="'Invoice nr 12221'"
                            :rules="descriptionRules"
                            prepend-icon="description"
                    />
                    <v-text-field
                            id="ref_nr"
                            v-model="payment.ref_nr"
                            :label="'Reference number' | t"
                            @keypress="onlyIntegers"
                            counter="19"
                            :rules="referenceNumberRules"
                            type="number"
                            placeholder="18002938120"
                            prepend-icon="arrow_forward"
                    />
                    <v-text-field
                            id="recipient_name"
                            v-model="payment.recipient_name"
                            :label="'Recipient name' | t"
                            placeholder="Meieni OÜ"
                            :rules="recipientNameRules"
                            prepend-icon="person"
                    />
                    <v-text-field
                            id="recipient_name"
                            v-model="payment.recipient_iban"
                            :label="'Recipient IBAN' | t"
                            placeholder="EE381010220196205220"
                            :rules="recipientIbanRules"
                            prepend-icon="receipt"
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-row>
            <v-btn :disabled="!form_validation" id="createPayment" class="mt-6" @click="addProductToDb">
                {{ "Create" | t }}
            </v-btn>
            <v-spacer/>
            <v-btn id="addPayment" class="mt-2 mr-3" @click="addPayment">
                <v-icon>add</v-icon>
            </v-btn>
        </v-row>

    </v-form>
</template>

<script>
import {mapActions} from "vuex";
import {paymentMixin} from "@/mixins/payment-mixin";

export default {
    name: "create-regular-payment",
    data() {
        return {
            emptyPayment: {
                id: 0,
                description: "",
                amount: 0.00,
                recipient_iban: "",
                recipient_name: "",
                ref_nr: ""
            },
            bulkPayments: [],
            arrayIndex: 0,
            panel: 0
        };
    },
    async mounted() {
        this.bulkPayments.push({...this.emptyPayment});
    },
    mixins: [paymentMixin],
    methods: {
        ...mapActions(["addProduct"]),
        async addProductToDb() {
            let payload = {
                ...this.bulkPayments,
                type: "bulk"
            };
            await this.addProduct(payload);
        },
        async addPayment() {
            this.arrayIndex++;
            this.panel = this.arrayIndex;
            let payment = {
                ...this.emptyPayment,
                id: this.arrayIndex
            }
            this.bulkPayments.push(payment);
        }
    }
};
</script>

<style scoped>
.asc-banks-list img {
    width: 140px;
    height: 54px;
    border-radius: 5px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 1px 3px rgba(0, 0, 0, 0.1);
}
</style>
